<template>
  <div class="terminal-toolbar">
    <div class="terminal-toolbar-top">
      <span class="terminal-toolbar-title">{{title}} ~</span>
      <span class="terminal-toolbar-icons">
        <div class="toolbar-icon">
          <i class="fas fa-window-minimize"></i>
        </div>
        <div class="toolbar-icon">
          <i class="fas fa-plus"></i>
        </div>
        <div class="toolbar-icon">
          <i class="fas fa-times"></i>
        </div>
      </span>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      default: ""
    }
  }
};
</script>
